/**
 * B1028 (the package half, landed with B1027) — THE SPINNER: an accent arc
 * turning on a faint ring, for an unknown wait under ~10 s (a progress bar
 * when the end is known; a skeleton for a laid-out empty page). CSS-only:
 * `.t-spinner` + `@keyframes t-spin`. Labelled = a `role="status"` with the
 * caller's words; unlabelled = decoration beside words that say the wait.
 * Under reduced motion the global reset stops the turn and the arc stays.
 */
import type { ReactNode } from "react";

export function Spinner(props: {
  /** 16 / 24 / 40 — "sm" / "md" (default) / "lg". */
  readonly size?: "sm" | "md" | "lg";
  /** The arc's ink: the accent (default) or the text ink. */
  readonly tone?: "accent" | "ink";
  /** Present = the spinner is the status itself and says this. */
  readonly label?: string;
  /**
   * B1028 — the "with a line" variant: present = ONE polite status line
   * whose words are this, the arc decoration beside them (`label` is then
   * not used — the words already say the wait).
   */
  readonly line?: string;
}): ReactNode {
  const cls = `t-spinner${props.size !== undefined && props.size !== "md" ? ` t-spinner--${props.size}` : ""}${props.tone === "ink" ? " t-spinner--ink" : ""}`;
  if (props.line !== undefined)
    return (
      <p className="t-spinner-line" role="status">
        <span className={cls} aria-hidden="true" />
        {props.line}
      </p>
    );
  return props.label !== undefined ? <span className={cls} role="status" aria-label={props.label} /> : <span className={cls} aria-hidden="true" />;
}
